import React, { useEffect, useState } from "react";
import { Box, FormControlLabel, Switch } from "@mui/material";
import OldIndex from "./OldIndex.tsx";
import NewIndex from "./NewIndex";

const localStorageKey = "OldProductenIndexView";

export default function Index() {
  const [renderOldView, setRenderOldView] = useState(!!localStorage.getItem(localStorageKey));
  useEffect(() => {
    if (renderOldView) {
      localStorage.setItem(localStorageKey, 1);
    } else {
      localStorage.removeItem(localStorageKey, 1);
    }
  }, [renderOldView]);
  return (
    <Box>
      {/*<AuthenticationWrapper permissionKey={"beta_feature"}>*/}
      <FormControlLabel
        checked={renderOldView}
        control={<Switch color={"primary"} />}
        label={"Switch to legacy view"}
        onChange={(e) => {
          setRenderOldView(e.target.checked);
        }}
      />
      {/*</AuthenticationWrapper>*/}
      {renderOldView ? <OldIndex /> : null}
      {!renderOldView ? <NewIndex /> : null}
    </Box>
  );
}
